import { renderCellGrayZeros } from 'app/common/templates-next/table-template'

import { Entity } from './types'
import styles from './render-table-cell.module.scss'

export type TitleCell = {
  columnKey: Entity.Title
  value: string | null
  type: 'isOnlyTitle' | 'isTotal'
}

const isTitleCell = (cellData: CommonCell): cellData is TitleCell => {
  return cellData?.columnKey === Entity.Title
}

type CommonCell = {
  columnKey: string
  value: string | null
}

export const renderTableCell = (cellData?: CommonCell) => {
  if (cellData && isTitleCell(cellData)) {
    if (cellData.type !== 'isOnlyTitle')
      return (
        <div>
          <div className={styles.subTitle}>{cellData.value}</div>
        </div>
      )
    return cellData.value
  }
  return renderCellGrayZeros(cellData)
}
